import { Button, Input, Toggle } from '@bitcine/cinesend-theme/dist'
import useStore from '../../hooks/use_store'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/use_auth'
import { modelTypes } from '../../constants/model_types'

const Details = ({ collection, schemaLocked }) => {
  const { updateModel } = useStore()
  const navigate = useNavigate()
  const { canEditModel: canEditCollection } = useAuth(modelTypes.Collection)
  const [name, setName] = useState(collection.name)
  const [outputKey, setOutputKey] = useState(collection.output_key)

  const update = (data) => {
    updateModel.mutate({
      endpoint: `collections`,
      id: collection.id,
      data,
    })
  }
  const { deleteModel } = useStore()
  const deleteList = () => {
    deleteModel.mutate(
      {
        endpoint: 'collections',
        id: collection.id,
      },
      {
        onSuccess: () => navigate(`/airlines/${collection.airline_id}/lists`),
      }
    )
  }
  return (
    <div className='border-b mb-4 pb-4 space-y-4'>
      <div className='flex justify-between border-b pb-4 mb-4'>
        <div className='font-semibold text-lg'>{collection?.name}</div>
        {canEditCollection && (
          <Button type='error' size='small' secondary icon={'delete_forever'} onClick={() => deleteList()}>
            Delete List
          </Button>
        )}
      </div>
      <div className='space-y-4'>
        <div className='font-semibold'>Details</div>
        <Input
          label='Name'
          value={name ?? ''}
          onChange={(e) => setName(e.target.value)}
          onBlur={(e) => update({ name: e.target.value })}
          disabled={!canEditCollection}
        />
        <Input
          label='Output Key'
          value={outputKey ?? ''}
          onChange={(e) => setOutputKey(e.target.value)}
          onBlur={(e) => update({ output_key: e.target.value })}
          disabled={!canEditCollection}
        />
        <div className='space-x-4'>
          <Toggle
            label='Is Localizable'
            checked={collection.is_localizable}
            onChange={(e) => update({ is_localizable: e.target.checked })}
            disabled={!canEditCollection || schemaLocked}
          />
          <Toggle
            label='Admin Only'
            checked={collection.admin_only}
            onChange={(e) => update({ admin_only: e.target.checked })}
            disabled={!canEditCollection}
          />
        </div>
      </div>
    </div>
  )
}

export default Details
